<h3-feedback-panel dialogTitle="Feedback" (panelClose)="close()">
  <h3-upsert-feedback
    [possibleErrorTags]="possibleErrorTags"
    [feedback]="selectedFeedback"
    (save)="save($event)"
  ></h3-upsert-feedback>
</h3-feedback-panel>
